<template>
  <div>
    <Form class="conter_form" ref="loginForm" :model="loginForm" :rules="loginValidate" @submit.native.prevent>
      <Tabs v-model="tabs" :animated="false" @on-click="changeTab">
        <TabPane :label="$t('key1006537')" name="accountNumber">
          <FormItem prop="emailOrMobile">
            <Input prefix="ios-person-outline" type="text" clearable v-model.trim="loginForm.emailOrMobile" @on-enter="signBtn" :placeholder="$t('key1006538')"></Input>
          </FormItem>
          <FormItem prop="password">
            <Input prefix="ios-lock-outline" type="password" password v-model.trim="loginForm.password" @on-enter="signBtn" :placeholder="$t('key1006539')"></Input>
          </FormItem>
          <FormItem prop="imageCode" v-if="talgVerificationCode">
            <div class="verificationcode_box">
              <Input prefix="ios-lock-outline" style="width: calc(100% - 125px);margin-right: 15px;" type="text" clearable v-model.trim="loginForm.imageCode" @on-enter="signBtn" :placeholder="$t('key1006540')"></Input>
              <img v-if="captchaImage" :alt="$t('key1001003')" width="110" height="40" :src="captchaImage" @click="getCaptcha"/>
            </div>
          </FormItem>
          <FormItem prop="distributorCurrency" v-if="pageType === '/register'">
            <Select v-model.trim="loginForm.distributorCurrency" :placeholder="$t('key1001008')" filterable transfer class="reset_select">
              <Option v-for="item in distributorCurrencyList" :label="item.currencyNameCode" :value="item.targetCurrencyCode">{{ item.currencyNameCode }}</Option>
            </Select>
          </FormItem>
        </TabPane>
        <TabPane :label="$t('key1006541')" name="sms">
          <FormItem prop="mobile">
            <Input type="text" clearable v-model.trim="loginForm.mobile" @on-enter="signBtn" :placeholder="$t('key1002629')">
              <Select slot="prepend" v-model="loginForm.mobileCountryCode" filterable transfer class="reset_select_input">
                <Option v-for="(item, index) in countrysList" :value="item.areaCode" :key="index">{{ item.areaCodeName }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem prop="code">
            <div class="verificationcode_box">
              <Input prefix="ios-lock-outline" type="text" :style="verificationcodeStyle" clearable v-model.trim="loginForm.code" @on-enter="signBtn" :placeholder="$t('key1006542')"></Input>
              <Button size="large" class="code_btn" @click="sendVerificationCode" :disabled="talgCode">{{ codeText }}</Button>
            </div>
          </FormItem>
          <FormItem prop="distributorCurrency" v-if="pageType === '/register'">
            <Select v-model.trim="loginForm.distributorCurrency" :placeholder="$t('key1001008')" filterable transfer class="reset_select">
              <Option v-for="item in distributorCurrencyList" :label="item.currencyNameCode" :value="item.targetCurrencyCode">{{ item.currencyNameCode }}</Option>
            </Select>
          </FormItem>
        </TabPane>
        <Checkbox v-model="readFlag" style="margin-bottom:20px;" v-if="pageType === '/register'">
          {{ $t('key1000519') }} <a class="select_color" @click.stop.prevent="gotoTermsOfService">{{ $t('key1000077') }}</a> {{ $t('key1000520') }} <a class="select_color" @click="gotoPrivacyPolicy">{{ $t('key1000078') }}</a>
        </Checkbox>
        <Button type="primary" style="width: 100%" size="large" @click="signBtn">{{ pageType !== '/register' ? $t('key1006520') : $t('key1006543') }}</Button>
        <ul class="link_box">
          <li class="link_item flex wid100P" :class="showRegister ? 'justify-content-between' : 'justify-content-end'">
            <span class="txt" style="color: #FD5425;" v-if="showRegister && !isAlibabaSite" @click="toRegister">{{ $t('key1000070') }}</span>
            <span class="txt" v-if="pageType !== '/register'" @click="toPassword">{{ $t('key1006544') }}</span>
          </li>
        </ul>
      </Tabs>
    </Form>
    <privacyPolicy ref="privacyPolicy"></privacyPolicy>
    <termsOfService ref="termsOfService"></termsOfService>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import {pageJump, commonSessionStorage, getAllCountrysData} from '@/utils/common';
import api from '@/api/';
import {removeToken} from '@/utils/cookie';
import privacyPolicy from '@/views/shopping/login/commom/privacyPolicy';
import termsOfService from '@/views/shopping/login/commom/termsOfService';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: '',
  mixins: [Mixin],
  props: {
    countrysBasisData: {
      type: Array,
      default: () => []
    },
    countrysBasisDataTalg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      tabs: 'accountNumber',
      pageType: null,
      readFlag: false,
      loginForm: {
        emailOrMobile: '',
        mobileCountryCode: '86',
        password: '',
        imageCode: '',
        mobile: '',
        code: '',
        distributorCurrency: null,
      },
      loginValidate: {
        emailOrMobile: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006535'), trigger: 'blur'}
        ],
        imageCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005478'), trigger: 'blur'}
        ],
        code: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006536'), trigger: 'blur'}
        ],
        password: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'), trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147'), trigger: 'blur'}
        ],
        distributorCurrency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000991'), trigger: 'change'}
        ],
      },
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      talgCode: false,
      captchaImage: '',
      uid: '',
      talgVerificationCode: false,
      countrysList: [],
      distributorCurrencyList: [],
    };
  },
  computed: {
    verificationcodeStyle() {
      let obj = {};
      if (this.$route.path === '/register') {
        obj = {
          width: this.languagesVal === 'zh-CN' ? '275px' : '245px',
          marginRight: '15px'
        };
      } else {
        obj = {
          width: this.languagesVal === 'zh-CN' ? '225px' : '195px',
          marginRight: '15px'
        };
      }
      return obj;
    },
    showRegister() {
      let href = window.location.href;
      let talg = false;
      if (href) {
        let link = href.split('u=')[1];
        if (link && !link.includes('yms-core-service') && this.pageType !== '/register') {
          talg = true;
        }
      }
      return talg;
    },
    isAlibabaSite() {
      return commonSessionStorage.getItem('isAlibabaSite');
    }
  },
  created() {
    this.systemCurrencyData();
    if (this.countrysBasisDataTalg) {
      this.countrysList = JSON.parse(JSON.stringify(this.countrysBasisData));
    } else {
      getAllCountrysData('en').then((data) => {
        this.countrysList = data;
      });
    }
    // 默认为中国手机号 +86
    this.loginForm.mobileCountryCode = '86';
    this.getLoginFailTimes().then(() => {
      this.getCaptcha();
    });
    this.pageType = this.$route.path;
  },
  methods: {
    gotoPrivacyPolicy() {
      this.$refs.privacyPolicy.modal = true;
    },
    gotoTermsOfService() {
      this.$refs.termsOfService.modal = true;
    },
    // 免费注册
    toRegister() {
      let href = window.location.href;
      if (href) {
        let link = href.split('u=')[1];
        if (link.includes('yms-shopping-service') || link.includes('yms-distributor-service')) {
          pageJump('/login.html#/register', '/yms-shopping-service', '_self');
        } else if (link.includes('yms-supplier-service')) {
          pageJump('/login.html#/supplierSettlement', '/yms-shopping-service', '_self');
        }
      }
    },
    // 找回密码
    toPassword() {
      pageJump('/login.html#/password', '/yms-shopping-service', '_self');
    },
    // 获取登录失败的次数
    getLoginFailTimes() {
      return new Promise(resolve => {
        this.axios.get(api.get_ymsUserInfo_getLoginFailTimes).then((response) => {
          this.talgVerificationCode = response.data.datas;
          resolve();
        });
      });
    },
    // 校验手机号/邮箱
    validateEmailOrMobile() {
      let v = this;
      let isMob = v.$regular.isPhone;
      let isMailbox = v.$regular.isMailbox;
      let mobile = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006535')));
        } else if (!(isMob.test(value) || isMailbox.test(value))) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002697')));
        } else {
          callback();
        }
        callback();
      };
      return mobile;
    },
    // 切换账号/短信登录
    changeTab() {
      let v = this;
      v.$refs.loginForm.resetFields();
      v.$nextTick(() => {
        v.loginForm.mobileCountryCode = '86';
      });
    },
    // 发送手机验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      v.$refs.loginForm.validateField("mobile", (error) => {
        if (!error) {
          talg = true;
        }
      });
      if (talg) {
        let query = {
          isvalid: 0, // 1 校验图片验证码  0 不校验
          messageType: v.loginForm.mobileCountryCode === '86' ? 5 : 18, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录  18 海外-登录
          mobile: v.loginForm.mobile,
          uid: this.uid,
          isValidHasRegistry: 1,
          mobileCountryCode: v.loginForm.mobileCountryCode
        };

        v.talgCode = true;
        v.axios.post(api.post_ymsUserSetting_sendMobileVerificationCode, query).then(response => {
          if (response.data.code === 0) {
            let time = 60;
            let timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000996'));
          } else {
            v.talgCode = false;
          }
        });
      }
    },
    signFail() {
      this.loginForm.password = '';
      this.loginForm.imageCode = '';
      this.loginForm.code = '';
      this.getCaptcha();
    },
    // 立即登录
    signBtn() {
      let v = this;
      let apiLogin = api.post_ymsUserInfo_login;
      let axiosType = 'post';
      if (v.pageType === '/register') {
        apiLogin = api.post_ymsUserInfo_settleIn;
        axiosType = 'put';
        if (!v.readFlag) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000518'));
          return;
        }
      }
      removeToken().then(() => {
        let url = (window.location.href).split('u=')[1];
        // 账号登录
        if (v.tabs === 'accountNumber') {
          let talg = false;
          v.$refs.loginForm.validateField("emailOrMobile", (error) => {
            if (!error) {
              v.$refs.loginForm.validateField("password", (error) => {
                if (!error) {
                  if (v.talgVerificationCode) {
                    v.$refs.loginForm.validateField("imageCode", (error) => {
                      if (!error) {
                        if (v.pageType === '/register') {
                          v.$refs.loginForm.validateField("distributorCurrency", (error) => {
                            if (!error) {
                              talg = true;
                            }
                          });
                        } else {
                          talg = true;
                        }
                      }
                    });
                  } else {
                    if (v.pageType === '/register') {
                      v.$refs.loginForm.validateField("distributorCurrency", (error) => {
                        if (!error) {
                          talg = true;
                        }
                      });
                    } else {
                      talg = true;
                    }
                  }
                }
              });
            }
          });
          if (talg) {
            let query = {
              emailOrMobile: v.loginForm.emailOrMobile,
              imageCode: v.talgVerificationCode ? v.loginForm.imageCode : '',
              password: v.loginForm.password,
              type: 'account',
              u: url,
              uid: v.talgVerificationCode ? this.uid : ''
            };
            if (v.pageType === '/register') {
              query.distributorCurrency = v.loginForm.distributorCurrency;
            }
            v.axios[axiosType](apiLogin, query).then(response => {
              if (response.data.code === 0) {
                localStorage.removeItem('talgVerificationCode');
                let link = decodeURIComponent(response.data.datas);
                if (v.$store.state.fromListing && window.parent) {
                  link = link.includes('?') ? link + '&from=listing' : '?from=listing';
                  window.parent.postMessage({
                    type: 'accountNumber',
                    from: 'ymsAuth'
                  }, '*');
                }

                /**
                 * 因为供应商、分销商系统用其他账号登录（例：供应商账号登录分销商系统）有异常校验提示框拦截，
                 * 要调接口确认是否开通分销商或者供应商，需要拿到当前登录的账号或邮箱
                 */
                function handleParam(originalURL) {
                  /*
                  * 处理emailOrMobile参数问题（因为调转页面之前拼接了emailOrMobile参数，会重复拼接emailOrMobile参数的情况），
                  * 拼接之前需要去掉链接中所有emailOrMobile参数，在重新拼接
                  */
                  const parts = originalURL.split('?');
                  const baseURL = parts[0]; // 基本 URL
                  const queryString = parts[1]; // 参数字符串
                  const queryParams = queryString.split('&');
                  const newParams = queryParams.filter(param => !param.startsWith('emailOrMobile=')).join('&');
                  const newURL = baseURL + (newParams ? '?' + newParams : '');
                  return newURL;
                }

                let href = handleParam(link);
                if (href) {
                  let path = href.includes('?') ? href + `&emailOrMobile=${query.emailOrMobile}` : `?emailOrMobile=${query.emailOrMobile}`;
                  window.location.href = path;
                }
              }
              // 输入报错提示三次，展示图片验证码
              else if (response.data.code === 122030) {
                v.talgVerificationCode = true;
                v.signFail();
              } else {
                v.signFail();
              }
            });
          }
        }
        // 短信登录
        else if (v.tabs === 'sms') {
          let talg = false;
          v.$refs.loginForm.validateField("mobile", (error) => {
            if (!error) {
              v.$refs.loginForm.validateField("code", (error) => {
                if (!error) {
                  if (v.pageType === '/register') {
                    v.$refs.loginForm.validateField("distributorCurrency", (error) => {
                      if (!error) {
                        talg = true;
                      }
                    });
                  } else {
                    talg = true;
                  }
                  if (talg) {
                    let query = {
                      emailOrMobile: v.loginForm.mobile,
                      mobileCountryCode: v.loginForm.mobileCountryCode,
                      code: v.loginForm.code,
                      distributorCurrency: v.loginForm.distributorCurrency,
                      type: 'sms',
                      u: url,
                      messageType: v.loginForm.mobileCountryCode === '86' ? 5 : 18 // 5-登录 或 18 海外-登录

                    };
                    v.axios[axiosType](apiLogin, query).then(response => {
                      if (response.data.code === 0) {
                        let link = decodeURIComponent(response.data.datas);
                        if (v.fromListing && window.parent) {
                          link = link.includes('?') ? link + '&from=listing' : '?from=listing';
                          window.parent.postMessage({
                            type: 'sms',
                            from: 'ymsAuth'
                          }, '*');
                        }
                        setTimeout(() => {
                          window.location.href = link;
                        });
                      } else {
                        v.signFail();
                      }
                    });
                  }
                }
              });
            }
          });
        }
      });
    },
    // 获取图片验证码
    getCaptcha() {
      // 获取当前的时间戳
      if (this.talgVerificationCode) {
        this.axios.get(api.yms_get_captcha).then((response) => {
          this.captchaImage = 'data:image/png;base64,' + response.data.datas.base64ImageCode;
          this.uid = response.data.datas.uid;
        });
      }
    },
    // 获取分销商币种
    async systemCurrencyData() {
      let response = await this.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=3`);
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        this.distributorCurrencyList = data.map((item) => {
          item.currencyNameCode = item.currencyName + ' ' + item.targetCurrencyCode;
          return item;
        });
      }
    }
  },
  components: {
    privacyPolicy,
    termsOfService
  }
};
</script>

<style scoped lang="less">
@import "src/assets/styles/shopping/common";

.conter_form {
  width: 400px;
  border-radius: 10px;
  background-color: #fff;
  margin-right: 410px;
  box-sizing: border-box;
  padding: 30px 25px 60px;

  /deep/ .ivu-form-item {
    input {
      height: 40px;
      line-height: 40px;
    }

    .ivu-input-prefix {
      display: flex;
      justify-content: center;
      align-items: center;

      .ivu-icon-ios-person-outline {
        font-size: 28px;
      }

      .ivu-icon-ios-lock-outline {
        font-size: 24px;
      }
    }

    .verificationcode_box {
      display: flex;
      justify-content: space-between;
      align-items: center;


      img {
        cursor: pointer;
      }

      .code_btn {
        display: block;
        min-width: 110px;
        padding: 0;
        text-align: center;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        background: #fff;
        color: #fd5425;
        border: solid 1px #fd5425;
        border-radius: 4px !important;

        &:hover {
          color: #fff;
          background: #fd5425;
          border-color: #fd5425;
        }
      }
    }
  }

  /deep/ .ivu-tabs-nav {
    width: 100%;
    display: flex;

    .ivu-tabs-tab {
      font-size: 16px;
      margin-right: 0;
      width: 50%;
      text-align: center;
    }

    .ivu-tabs-ink-bar {
      width: 50% !important;
    }
  }

  /deep/ .ivu-tabs-content {
    margin-top: 25px;
  }

  .link_box {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .link_item {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }

      .line_item {
        display: inline-block;
        margin: 0 8px;
      }

      .txt {
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: @subject_color;
        }
      }
    }
  }

  /deep/ .reset_select_input {
    width: 120px;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .reset_select {
    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .ivu-input-group-prepend {
    background-color: transparent;
  }
}

</style>

<style>
.conter_form .ivu-input-icon, .conter_form .ivu-input-suffix i {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>
